import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { cache, createEventBus, removeEventBus } from '@/util'
import api from '@home/api'
@Component({
  components: {},
})
export default class UserDetail extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) person!: orgmap.UserItem
  @Prop({ type: String }) personCode!: string

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  userInfo: any = {}
  isModalStatus: boolean = false
  avatar = {
    url: '',
    loading: false,
  }
  email: any = {} as any

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  getImage(email?: string) {
      //debugger
    if (email && email.indexOf('/') == -1) {
      this.avatar.loading = true
      cache.avatar.get(email).then((url: string) => {
        this.avatar.url = url
        this.avatar.loading = false
      })
    }
  }

  error(e: Event) {
    var elem = e.srcElement as HTMLImageElement
    elem.src = '/cm/gres/v1/img/ghost_loading.png'
  }

  errorGhost(e: Event) {
    var elem = e.srcElement as HTMLImageElement
    elem.src = '/cm/gres/faux/images/ghost.png'
  }

  showModal(flag: boolean) {
    this.isModalStatus = flag
  }

  async writeEmail() {
    if (this.person.email) {
      this.$router.push({
        path: '/mail/write',
        query: { id: '', type: 'draft', uid: this.person.email },
      })
    } else {
      await(window as any).alertAsync('이메일 정보가 없습니다.')
    }
  }

  officeTel() {
    var addNumber = this.person.officeTel?.length === 4 ? '061-460-' : '';
    location.href = 'tel:' + addNumber + this.person.officeTel;
  }

  call(phoneNumber: string) {
    let Param: any = {}
    Param.Type = 'Call'
    Param.PhoneNumber = phoneNumber
    this.invokeCSCode(JSON.stringify(Param))
  }

  async invokeCSCode(data: any) {
    try {
      if ((window as any).invokeCSharpAction) {
        ;(window as any).invokeCSharpAction(data)
      } else {
        var obj = JSON.parse(data)
        const link = document.createElement('a')
        link.href = 'tel:' + obj.PhoneNumber
        link.click()
        ;(process as any).nextTick(() => link.remove())
      }
    } catch (err) {
      await(window as any).alertAsync(err)
    }
  }

  back() {
    this.$emit('detailViewClose')
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  created() {
    createEventBus(window, 'header-back', this.back)
    if(this.person){
      api.orgmap.getCompanyName(this.person.comCode).then((res)=>{
        this.person.companyName = res.companyName
      })
    }
  }

  beforeDestroy() {
      removeEventBus(window, 'header-back', this.back)
  }

  mounted() {
    this.getImage(this.person.email)
  }
}
